import { Col } from "react-bootstrap";
import ContadorBadge from "shared/components/badges/ContadorBadge";
import { FaGlobe, FaExclamationTriangle, FaTimes } from "react-icons/fa";
import Labels from "./NotificacaoMenuLabels.json";
import { NotificacaoSirensDTO, TipoCategoriaNotificacao, TipoConteudo } from "types/dto/NotificacaoSirensDTO";
import IntegracaoV1 from "shared/util/integrarFrontEndV1Functions";
import { Tooltip } from "@material-ui/core";

interface SeletorCondominioContextoProps {
  showMenu: boolean;

  totalNaoLidas: number;
  totaisNaoLidasCategoria: Map<string, number>;
  ultimasNotificacoesCategoria: Map<string, NotificacaoSirensDTO>;
}

const NotificacaoMenu: React.FC<SeletorCondominioContextoProps> = (props) => {
  const { redirectToV1 } = IntegracaoV1();
  const renderIcon = (tipoCategoria: TipoCategoriaNotificacao) => {
    switch (tipoCategoria) {
      case TipoCategoriaNotificacao.INFORMATIVO:
        return <FaGlobe className="notificacao-icon" />;
      case TipoCategoriaNotificacao.PENDENCIA:
        return <FaExclamationTriangle className="notificacao-icon" />;
      case TipoCategoriaNotificacao.ERRO:
        return <FaTimes className="notificacao-icon" />;
    }
  };

  const renderSumarioCategoria = (tipoCategoria: TipoCategoriaNotificacao) => {
    let totalNaoLidoCategoria = props.totaisNaoLidasCategoria.get(tipoCategoria.toString());
    let ultimaNotificacaoCategoria = props.ultimasNotificacoesCategoria.get(tipoCategoria.toString());

    if (!ultimaNotificacaoCategoria) {
      return <li></li>;
    }

    let conteudo = ultimaNotificacaoCategoria.conteudo.replaceAll(".", "_") as TipoConteudo;

    return (
      <li>
        <div onClick={() => redirectToV1("/notificacao")}>
          {renderIcon(tipoCategoria)}
          <span className="notificacao-titulo">{Labels.categoria[tipoCategoria]}</span>
          <br />

          <Col sm="12" className="box-descricao">
            <Col sm="10" className="notificacao-descricao">
              {Labels.conteudo[conteudo]}
            </Col>
            <Col sm="2">
              <Tooltip title="Notificações não lidas">
                <ContadorBadge
                  bgColor="#1c84c6"
                  title="Não lidas"
                  contador={totalNaoLidoCategoria}
                  showZero
                ></ContadorBadge>
              </Tooltip>
            </Col>
          </Col>

          <br />
          <hr />
        </div>
      </li>
    );
  };

  return (
    <div className="notificacao-menu">
      {props.showMenu && (
        <div className="notificacao-box ">
          <div className="notificacao-border">Notificação</div>

          <ul className="notificacao-list">
            {renderSumarioCategoria(TipoCategoriaNotificacao.INFORMATIVO)}
            {renderSumarioCategoria(TipoCategoriaNotificacao.PENDENCIA)}
            {renderSumarioCategoria(TipoCategoriaNotificacao.ERRO)}

            <li>
              <a className="exibir-todas" onClick={() => redirectToV1("/notificacao")}>
                Exibir todas as notificações
              </a>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default NotificacaoMenu;
